<template>
  <div>
    <el-table :data="list">
      <el-table-column prop="id" label="ID"></el-table-column>

      <el-table-column prop="name" label="名称">
        <template slot-scope="scope">{{
          scope.row.name && scope.row.name.zh
        }}</template>
      </el-table-column>
      <el-table-column prop="ownerStatus" label="掌门状态">
        <template slot-scope="scope">
          <el-tag
            type="default"
            v-if="
              scope.row.ownerStatus === 0 &&
                scope.row.nextOwnerChangeTime >= new Date().getTime()
            "
            >准备竞选</el-tag
          >
          <el-tag
            type="info"
            v-if="
              scope.row.ownerStatus === 0 &&
                scope.row.nextOwnerChangeTime < new Date().getTime()
            "
            >无</el-tag
          >
          <el-tag type="success" v-if="scope.row.ownerStatus === 1">有</el-tag>
          <el-tag type="danger" v-if="scope.row.ownerStatus === 2"
            >竞选中</el-tag
          >
          <el-tag type="warning" v-if="scope.row.ownerStatus === 3"
            >考虑中</el-tag
          >
          <el-tooltip
            v-if="scope.row.ownerStatus === 3"
            class="item"
            effect="dark"
            placement="top-start"
          >
            <div slot="content">掌门价格： {{ scope.row.ownerPrice }}</div>
            <div slot="content">
              掌门考虑结束时间： {{ scope.row.nextOwnerEndTime | moment }}
            </div>
            <i
              style="cursor: pointer;margin-left: 4px;"
              class="el-icon-question"
            ></i>
          </el-tooltip>
          <el-tooltip
            v-if="
              scope.row.ownerStatus === 2 ||
                (scope.row.ownerStatus === 0 &&
                  scope.row.nextOwnerChangeTime >= new Date().getTime())
            "
            class="item"
            effect="dark"
            placement="top-start"
          >
            <div slot="content">掌门价格： {{ scope.row.ownerPrice }}</div>
            <div slot="content">
              掌门竞选开始时间： {{ scope.row.nextOwnerChangeTime | moment }}
            </div>
            <div slot="content">
              掌门竞选结束时间： {{ scope.row.nextOwnerChangeEndTime | moment }}
            </div>
            <div slot="content">
              每次递增价格： {{ scope.row.ownerPriceStep }}
            </div>
            <div slot="content">
              每次递增分钟呢数： {{ scope.row.ownerTimeMinuteStep }}
            </div>
            <i
              style="cursor: pointer;margin-left: 4px;"
              class="el-icon-question"
            ></i>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="ownerCreateTime" label="掌门生成/流局时间">
        <template slot-scope="scope">{{
          scope.row.ownerCreateTime | moment
        }}</template>
      </el-table-column>
      <el-table-column prop="canLock" label="锁仓开关">
        <template slot-scope="scope">
          <el-switch
            active-color="#13ce66"
            :value="scope.row.canLock === 1"
            @change="canLockChange(scope.row, 1 - scope.row.canLock)"
          ></el-switch>
        </template>
      </el-table-column>
      <el-table-column prop="unlock" label="解锁状态">
        <template slot-scope="scope">
          <el-switch
            :value="scope.row.status === 1"
            @change="unLockChange(scope.row)"
          ></el-switch>
          <el-tooltip
            v-if="scope.row.status === 1"
            class="item"
            effect="dark"
            placement="top-start"
          >
            <div slot="content">
              结束时间： {{ scope.row.nextUnlockEndTime | moment }}
            </div>
            <i
              style="cursor: pointer;margin-left: 4px;"
              class="el-icon-question"
            ></i>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="memberCount" label="成员数量"></el-table-column>
      <el-table-column prop="lockAmount" label="锁仓总量">
        <template slot-scope="scope">
          <router-link
            class="link"
            :to="{
              path: '/home/league/records',
              query: { leagueId: scope.row.id }
            }"
            >{{ scope.row.lockAmount }}</router-link
          >
        </template>
      </el-table-column>
      <!-- <el-table-column prop="createTime" label="创建时间">
        <template slot-scope="scope">{{scope.row.createTime | moment}}</template>
      </el-table-column>-->
      <el-table-column label="操作" width="360">
        <template slot-scope="scope">
          <el-tooltip content="查看">
            <el-button
              type="primary"
              size="small"
              icon="el-icon-view"
              circle
              @click="viewDetail(scope.row, 'detail')"
            ></el-button>
          </el-tooltip>
          <!-- <el-button
            type="danger"
            icon="el-icon-delete"
            size="small"
            @click="removeItem(scope.row.id)"
          ></el-button>-->
          <!-- <el-button type="warning" size="small" @click="viewDetail(scope.row, 'unlock')">解锁</el-button> -->

          <router-link
            class="link-button"
            :to="{
              path: '/home/league/settle',
              query: { leagueId: scope.row.id }
            }"
          >
            <el-button size="small">结算</el-button>
          </router-link>
          <el-button
            type="danger"
            size="small"
            v-if="scope.row.ownerStatus === 1"
            @click="ownnerConsiderChange(scope.row)"
            >掌门到期</el-button
          >

          <el-button
            type="danger"
            size="small"
            v-if="scope.row.canLock === 0 && scope.row.status === 1"
            @click="closeLeague(scope.row.id)"
            >解散</el-button
          >

          <el-button
            v-if="scope.row.ownerStatus === 0"
            type="warning"
            size="small"
            @click="ownnerChange(scope.row)"
            >{{
              scope.row.nextOwnerChangeTime < new Date().getTime()
                ? '掌门竞选'
                : '重设竞选'
            }}</el-button
          >

          <!-- <el-tooltip content="投资记录">
          <router-link :to="`/home/foundation/records/${scope.row.id}`" class="link-button">
            <el-button type="success" size="small" circle icon="el-icon-tickets"></el-button>
          </router-link>
          </el-tooltip>-->
        </template>
      </el-table-column>
    </el-table>
    <detail :detailType="detailType" @refresh="refresh()"></detail>
    <el-dialog
      :visible="!!editingUnlockRow"
      :title="
        editingUnlockRow &&
          '设置' +
            (editingUnlockRow.name && editingUnlockRow.name.zh) +
            '锁仓结束时间'
      "
      width="400px"
      @close="editingUnlockRow = null"
    >
      <el-date-picker
        v-model="nextUnlockEndTime"
        value-format="timestamp"
        type="datetime"
        placeholder="结束时间"
      ></el-date-picker>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="doUnlock">确定</el-button>
      </span>
    </el-dialog>
    <owner-consider
      :editingConsiderRow="editingConsiderRow"
      @close="editingConsiderRow = null"
      @refresh="refresh()"
    ></owner-consider>
    <owner-change
      :editingChangeRow="editingChangeRow"
      @close="editingChangeRow = null"
      @refresh="refresh()"
    ></owner-change>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import Detail from '../Detail';
import OwnerChange from '../OwnerChange';
import OwnerConsider from '../OwnerConsider';

export default {
  name: 'leagueList',
  data() {
    return {
      detailType: 'detail',
      editingUnlockRow: null,
      nextUnlockEndTime: null,
      editingConsiderRow: null,
      editingChangeRow: null
    };
  },
  components: {
    Detail,
    OwnerChange,
    OwnerConsider
  },
  computed: {
    ...mapState('league', ['list'])
  },
  methods: {
    ...mapActions('league', [
      'remove',
      'update',
      'setUnlock',
      'setLock',
      'close'
    ]),
    ...mapMutations('league', ['setEditingProject']),
    viewDetail(project, detailType) {
      this.setEditingProject(project);
      this.detailType = detailType;
    },
    refresh() {
      this.$emit('refresh');
    },
    canLockChange(item, canLock) {
      this.setLock({ leagueId: item.id, canLock }).then(() => {
        this.$emit('refresh');
      });
    },
    removeItem(id) {
      this.$confirm('确认要删除该门派吗？', '提示', { type: 'warning' }).then(
        () => {
          this.remove(id).then(() => {
            this.$message.success('删除成功！');
            this.refresh();
          });
        }
      );
    },
    closeLeague(id) {
      this.$confirm('确认要解散门派下的成员吗？', '提示', {
        type: 'warning'
      }).then(() => {
        this.close(id).then(() => {
          this.$message.success('操作成功！');
          this.refresh();
        });
      });
    },
    unLockChange(item) {
      if (item.status === 0) {
        this.editingUnlockRow = item;
      } else {
        this.setUnlock({ leagueId: item.id, toggle: false }).then(() => {
          this.editingUnlockRow = null;
          this.refresh();
        });
      }
    },
    ownnerConsiderChange(item) {
      this.editingConsiderRow = item;
    },
    ownnerChange(item) {
      this.editingChangeRow = item;
    },
    doUnlock() {
      if (!this.nextUnlockEndTime) {
        this.$message.error('请输入结束时间');
        this.editingUnlockRow = null;
        return;
      }
      this.setUnlock({
        leagueId: this.editingUnlockRow.id,
        toggle: true,
        endTime: this.nextUnlockEndTime
      }).then(() => {
        this.editingUnlockRow = null;
        this.refresh();
      });
    }
  }
};
</script>

<style lang="less" scoped>
.link-button {
  margin: 0 10px;
}
.link {
  text-decoration: underline;
}
</style>
